// extracted by mini-css-extract-plugin
export default {"SegmentedControl":"SegmentedControl_SegmentedControl__sBxP8","Button":"SegmentedControl_Button__2t4f9","ButtonSelected":"SegmentedControl_ButtonSelected__CWdwf"};